module.exports = __webpack_public_path__ + "img/Home4.a2e33160.png";